<div class="base">
    <div class="header">Projecten & Calculaties</div>
    <div class="body">
        <div class="options">
            <div class="search-bar" [class.selected]="searchBarSelected">
                <input #search (keyup)="searchInputChange(search.value)" (focus)="focusInput()" (blur)="blurInput()"
                    placeholder="Zoeken (projectnummer en -omschrijving)" />
                <div class="fas fa-search"></div>
            </div>

            <div class="filters">
                <span class="title">Filters</span>
                <div class="filter-option button-new" [class.inactive]="projFilterActive$ | async | not"
                    (click)="toggleFilterValue('isActive')">
                    <div class="description">Lopend</div>
                </div>
                <div class="filter-option button-new" [class.inactive]="projFilterClosed$ | async | not"
                    (click)="toggleFilterValue('isClosed')">
                    <div class="description">Afgesloten</div>
                </div>
                <div class="filter-option button-new inactive" [class.inactive]="projFilterCalculations$ | async | not"
                    (click)="toggleFilterValue('hasCalculation')">
                    <div class="description">Met calculaties</div>
                </div>

                <!-- <div class="fas fa-filter" (click)="toggleFilterOpenProjectsOnly()"
                    [class.inactive]="filterOpenProjectsOnly | not" title="Alleen lopende projecten"></div> -->
            </div>
        </div>
        <div class="project-list">

            <div class="scrollable">

                <!-- Loading spinner -->
                <ng-template #spinner>
                    <div class="spinner-container" *ngIf="loading">
                        <div class="spinner">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </ng-template>

                <ng-container *ngIf="projects$ | async as projects; else spinner">

                    <!-- Row for the project -->
                    <div *ngFor="let project of projects; let i = index" class="project"
                        [class.closed]="project.active | not">
                        <div class="project-details">
                            <div class="id">{{ project.id }}</div>
                            <div class="item">
                                <div class="description">{{ project.description }}</div>
                                <div class="actions" *ngIf="project.active">+
                                    <div class="action" (click)="createCalculation(project, 'stabu', $event)">STABU
                                    </div>
                                    <div class="action" (click)="createCalculation(project, 'stabu-en', $event)">STABU
                                        EN</div>
                                    <div class="action variations" (click)="createCalculation(project, 'mmw', $event)">
                                        Meer/Minder (leeg)</div>
                                </div>
                            </div>
                            <div class="date">{{ project.created | date:'dd-MM-yyyy' }}</div>
                        </div>

                        <!-- Define a reusable template for a list of calculations -->
                        <ng-template #calcList let-calculations="calculations" let-project="project">
                            <ng-container *ngFor="let calc of calculations">

                                <!-- Render each calculation -->
                                <div class="calculation" [class.closed]="project.active | not"
                                    (click)="openCalculation(project, calc)">

                                    <div class="item">
                                        <div class="color-code"
                                            [class.stabu]="['stabu', 'stabu-en'] | includes:calc.meta.templateName"
                                            [class.variations]="calc.meta.templateName | equals: 'mmw'">
                                        </div>
                                        <div class="template">
                                            <div class="template-name"
                                                [class.stabu]="['stabu', 'stabu-en'] | includes:calc.meta.templateName"
                                                [class.variations]="calc.meta.templateName | equals: 'mmw'">
                                                {{ calc.meta.templateName }}
                                            </div>
                                        </div>
                                        <div class="description">{{ calc.meta.description }}</div>
                                        <div class="version">v{{ calc.meta.currentVersion }}</div>
                                        <div class="actions">
                                            <div class="action" (click)="openCalculation(project, calc)">Open</div>
                                            <div class="action" *ngIf="project.active"
                                                (click)="createVariationsFromCalculation(project, calc, $event)">
                                                Meer/Minder
                                            </div>
                                        </div>
                                    </div>

                                    <div class="date">{{ calc.meta.versionDate | date:'dd-MM-yyyy' }}</div>
                                </div>

                                <!-- If there are linked calculations, render them one level deeper -->
                                <div class="linked-calculations" *ngIf="calc.children?.length | greaterThan: 0">
                                    <ng-container [ngTemplateOutlet]="calcList"
                                        [ngTemplateOutletContext]="{ calculations: calc.children, project: project }">
                                    </ng-container>
                                </div>

                            </ng-container>

                        </ng-template>

                        <!-- Use the template initially for the project’s top-level calculations -->
                        <div class="calculations" *ngIf="project?.calculations?.length | greaterThan: 0">
                            <ng-container [ngTemplateOutlet]="calcList"
                                [ngTemplateOutletContext]="{ calculations: project.calculations, project: project }">
                            </ng-container>
                        </div>

                    </div>

                </ng-container>

            </div>
        </div>
    </div>
</div>